module.exports = __webpack_public_path__ + "img/ic-ic-new-shop-w.b44223ad.svg";